/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Adminlogin, clearError } from "../Features/Adminlogindata";
import { AppDispatch, RootState } from "../Appstore/store";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { toast } from "sonner";

type LoginProps = {
  setIsLoggedIn: (value: boolean) => void;
};

const Login: React.FC<LoginProps> = ({ setIsLoggedIn }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { loading } = useSelector((state: RootState) => state.login);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/admin/dashboard");
    }
  }, []);

  const handleLogin = async (values: { email: string; password: string }) => {
    dispatch(clearError());
    const result = await dispatch(Adminlogin(values));
    if (result.payload.status === "success") {
      setIsLoggedIn(true);
      navigate("/admin/dashboard");
      const token = result.payload.token;
      localStorage.setItem("token", token);
      toast.success(result?.payload?.message || "Login success");
    }
    else {
      toast.error(result?.payload?.message || "Something wrong");
    }
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string()
      .required("Password is required")
  });

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo text-decoration-none">
          <Link to="#" className="text-decoration-none fs-1 fw-bold">
            Admin
          </Link>
        </div>
        <div className="card">
          <div className="card-body login-card-body rounded-3">
            <p className="login-box-msg">Login to start your session</p>
            <Formik
              initialValues={{ email: "", password: "" }}
              validationSchema={validationSchema}
              onSubmit={handleLogin}
            >
              {({ isSubmitting, errors, touched }) => (
                <Form>
                  <div className="mb-3">
                    <div className="input-group">
                      <Field
                        type="text"
                        name="email"
                        className={`form-control ${touched.email && errors.email ? "is-invalid" : ""
                          }`}
                        placeholder="Email"
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-envelope" />
                        </div>
                      </div>
                    </div>
                    {touched.email && errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </div>

                  <div className="mb-3">
                    <div className="input-group">
                      <Field
                        type="password"
                        name="password"
                        className={`form-control ${touched.password && errors.password
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder="Password"
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-lock" />
                        </div>
                      </div>
                    </div>
                    {touched.password && errors.password && (
                      <div className="text-danger">{errors.password}</div>
                    )}
                  </div>

                  <div>
                    <button
                      className="btn btn-primary w-100"
                      type="submit"
                      disabled={loading || isSubmitting}
                    >
                      Login
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
